import React from 'react';
import { Switch, Route } from 'react-router-dom';

import { Tabs, Tab } from '../../components/route-tabs';
import { groups, LAW, DECREE, LAW_PASSPORT, DECREE_PASSPORT, LAW_Y, DECREE_Y } from './groups';
import List from './List';
import Single from './Single';

export default () => (
	<>
		<Tabs>
			<Tab path="/admin/documents/laws" exact title="Законы">
				<List group={LAW} />
			</Tab>
			<Tab path="/admin/documents/laws-ykt" exact title="Законы на якутском">
				<List group={LAW_Y} />
			</Tab>
			<Tab path="/admin/documents/decrees" exact title="Постановления">
				<List group={DECREE} />
			</Tab>
			<Tab path="/admin/documents/decrees-ykt" exact title="Постановления на якутском">
				<List group={DECREE_Y} />
			</Tab>
			<Tab path="/admin/documents/law-projects" exact title="Законопроекты">
				<List group={LAW_PASSPORT} />
			</Tab>
			<Tab path="/admin/documents/decree-projects" exact title="Проекты постановлений">
				<List group={DECREE_PASSPORT} />
			</Tab>
		</Tabs>
		<Route path="/admin/documents/laws/:id" component={Single} />
		<Route path="/admin/documents/laws-ykt/:id" component={Single} />
		<Route path="/admin/documents/decrees/:id" component={Single} />
		<Route path="/admin/documents/decrees-ykt/:id" component={Single} />
		<Route path="/admin/documents/law-projects/:id" component={Single} />
		<Route path="/admin/documents/decree-projects/:id" component={Single} />
	</>
);
